/*
 * fn: buildAdvancedRoute
 *
 * Builds the URL search param value for a set of advanced filters
 *
 */
import {
  type FilterAdvancedType,
  isFilterAdvancedCardType,
  isFilterAdvancedCountType,
  isFilterAdvancedPriceType,
} from '@/defs/filters'

export const buildAdvancedRoute = (advancedFilters?: FilterAdvancedType[]) =>
  advancedFilters
    ?.map((filter) => {
      if (isFilterAdvancedCardType(filter)) return `${filter.slug === 'withCard' ? 'in' : 'out'}=${filter.card}`
      if (isFilterAdvancedCountType(filter) || isFilterAdvancedPriceType(filter))
        return `${filter.slug}:${filter.operator}=${filter.number}`
    })
    .filter((item) => !!item)
    .join(';') || undefined
